
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".faq_accordion_sec .accordion_header").forEach(header => {
        header.addEventListener("click", () => {
            const content = header.nextElementSibling;

            if (content.style.height && content.style.height !== "0px") {
                // CLOSE
                content.style.height = content.scrollHeight + "px";

                requestAnimationFrame(() => {
                    content.style.height = "0px";
                });

                // remove open class
                header.classList.remove("accordion_adv");

            } else {
                // OPEN
                content.style.height = content.scrollHeight + "px";

                // add open class
                header.classList.add("accordion_adv");

                content.addEventListener("transitionend", function handler() {
                    content.style.height = "auto";
                    content.removeEventListener("transitionend", handler);
                });
            }
        });
    });
});

$(document).ready(function () {
    $('.main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    asNavFor: '.thumb-slider',
    autoplay: false,
    autoplaySpeed: 11000,
    dots: false,
    responsive: [
    {
        breakpoint: 767,
        settings: {
        slidesToShow:1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        variableWidth: false,
        arrows: true,
        }
    }
    ]
});

$('.thumb-slider').slick({
    slidesToShow:5,
    slidesToScroll: 1,
    asNavFor: '.main-slider',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    arrows: false,
    rtl: false,
    });
});